import React from "react";
import {View, Text, StyleSheet, Image, TouchableOpacity, TextInput} from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";
import Config from "../../Config";
import {Ionicons} from "@expo/vector-icons";
import AntDesign from "@expo/vector-icons/AntDesign";
import {Video} from "expo-av";
const Examtext = (props) => {

    let dafaultstrings = props.question.text;
    const [strings, setStrings] = React.useState( props.question.text);
    let Count = strings.length;
    const [results, setResults] = React.useState('');

    const sendResult = ()=>{

        //save result
        props.setResults((prevState)=>[
            {id : props.question.id , answer :results} ,
            ...prevState
        ]);
        props.setNumber((prevState)=>(prevState + 1))
    }
    return (
        <View style={styles.container}>

            {props.question.type === 1 ?
                <Image style={styles.image} source={{uri : `${Config.dl}/${props.question.url}`}} />
                :
                <Video
                    style={styles.video}
                    source={{
                        uri: `${Config.dl}/${props.question.url}`,
                    }}
                    useNativeControls
                    resizeMode="contain"

                    shouldPlay={true}
                    useNativeControls={true}

                    // isLooping
                    // onReadyForDisplay={() => {setIsPreloading(false);}}
                    // onPlaybackStatusUpdate={status => setStatus(() => status)}
                />
            }
            <Text style={styles.text}>
                {props.question.ask}
            </Text>

            <TextInput      editable={false}  style={styles.awnser} value={results} placeholder={' - - - - - -'}/>



            <View style={styles.buttons}>

                {strings.map((item, index) =>
                    <TouchableOpacity key={index}  style={styles.button} onPress={() => {
                        setResults(results + item);
                        setStrings(strings.filter((string,indexitem) => indexitem !== index));
                    }}>
                        <Text style={styles.label} >
                            {item}
                        </Text>
                    </TouchableOpacity>
                )}

                <TouchableOpacity   style={styles.button} onPress={() => {
                    setStrings(dafaultstrings);
                    setResults('');
                }}>
                    <Ionicons name="refresh" size={RFValue(23)} color="black" />
                </TouchableOpacity>
                {strings.length == 0 &&
                    <TouchableOpacity   style={styles.button} onPress={sendResult}>
                        <AntDesign name="check"  size={RFValue(23)} color="black" />
                    </TouchableOpacity>
                }
            </View>

        </View>
    )
};

const styles = StyleSheet.create({

    buttons : {
         flexDirection : 'row-reverse',
        justifyContent : 'center',
        alignItems: 'center',
        flexWrap : 'wrap',


    },

    button : {
         marginVertical : RFValue(4),
        marginHorizontal : RFValue(4),
        backgroundColor : 'white',
        borderRadius : RFValue(20),
        borderWidth : 1,
        borderColor : '#E7E9F2',
        padding : RFValue(20),
        justifyContent : 'center',
        alignItems: 'center',
        width : RFValue(65),
        height : RFValue(65),
    },

    awnser : {
        fontSize: RFValue(20),
        fontFamily: 'ykb',
        color: '#000',
        textAlign: 'center',
    },

    label : {
        fontSize: RFValue(20),
        fontFamily: 'ykb',
        color: Config.maincolor,
        textAlign: 'center',
    },

    text : {
       fontSize: RFValue(14),
       fontFamily: 'ykb',
        color: Config.maincolor,
        marginBottom : RFValue(20),

    },
    container: {
        flex: 1,


    },
    image: {
        marginBottom : RFValue(20),
        width: '100%',
        height : RFValue(180),
        borderRadius: RFValue(15),
    },
    video : {
        width: '100%',
        height: RFValue(200),
        borderRadius: RFValue(15),
        marginLeft : RFValue(10),
        backgroundColor : 'black',
        borderColor : Config.maincolor,
        borderWidth : 1,
        marginBottom : RFValue(20),

    },
});
export default Examtext;